import { convertLabelMapToConfig, mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.AreSieveMassesCumulative`]: 'Sieve Retained Masses Are',
      [`${prefix}.Preparation.MaterialDryMassObtainedBy`]: 'Material Dry Mass Obtained by',
      [`${prefix}.Preparation.AggregateType`]: 'Aggregate Type',
      [`${prefix}.Preparation.VisualNominalParticleSize`]: 'Nominal Particle Size',
      [`${prefix}.Preparation.MaterialContainsAsphaltFiller`]: 'Material contains asphalt filler',
      [`${prefix}.Preparation.MaterialWashed`]: 'Material Washed',
      [`${prefix}.Preparation.NominalParticleSize`]: 'Nominal Particle Size',
      [`${prefix}.Preparation.AddSieveSizesBasedOnSpecification`]: 'Sieves Are Added',
      [`${prefix}.WholePortion.Masses.DryMass`]: 'Material Dry Mass',
      [`${prefix}.WholePortion.Preparation.StateBeforePreparation`]: 'Condition of Received Sample',
      [`${prefix}.WholePortion.Masses.AssociatedBinderOrBitumenContentTest.ExternalTest.Results.AggregateMass`]:
        'Material Dry Mass',
      [`${prefix}.WholePortion.Masses.AssociatedBinderOrBitumenContentTest.ExternalTest.Results.VisualNominalParticleSize`]:
        'Nominal Particle Size',
      [`${prefix}.WholePortion.Masses.MassMeasurement.Equipment.Balance`]: 'Sampling Balance',
      [`${prefix}.WholePortion.Masses.MassMeasurement.TareMass`]: 'Tare Mass',
      [`${prefix}.WholePortion.Masses.MassMeasurement.TareAndDryMass`]: 'Tare and Dry Mass',
      [`${prefix}.WholePortion.Masses.MassMeasurement.DryMass`]: 'Material Dry Mass',
      [`${prefix}.WholePortion.Sieving.Equipment.Balance`]: 'Balance',
      [`${prefix}.WholePortion.Sieving.Equipment.SieveSet`]: 'Sieve Set',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Equipment.Balance`]: 'Sampling Balance',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Equipment.DryMassBalance`]:
        'Dry Mass Balance',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Equipment.DryingEquipment`]: 'Drying by',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Equipment.Oven`]: 'Oven',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Equipment.Hotplate`]: 'Hotplate',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Equipment.MicrowaveOven`]:
        'Microwave Oven',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Equipment.InfraredLight`]:
        'Infrared Light',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Equipment.DryingTemperature`]:
        'Oven Temperature',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Equipment.Balance`]: 'Drying Balance',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Equipment.DryMassBalance`]:
        'Dry Mass Balance',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.DryingTray.ContainerLabel`]: 'Tare ID',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.DryingTray.ContainerMass`]:
        'Drying Tare Mass',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.DryingTray.WetSoilAndContainerMass`]:
        'Tare and Portion Wet Mass',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.DryingTray.WetSoilMass`]:
        'Portion Wet Mass',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.DryingTray.DateTimePlacedInOvenLocal`]:
        'Date and Time in Oven',
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.DryingTray.DryMassReadings.DryingTime`]: `Drying Time`,
      [`${prefix}.WholePortion.Masses.MassMeasurement.MeasuredConstantDryMass.Measurements.TotalDryMass`]:
        'Material Dry Mass',
      [`${prefix}.Results.ChartOptions.CurveFittingAlgorithm`]: 'Curve Fitting',
      [`${prefix}.Results.ChartOptions.JoinSpecificationPoints`]: 'Join specification points on chart',
      [`${prefix}.Results.CoefficientOfUniformity`]: 'Coefficient of Uniformity (Cu)',
      [`${prefix}.Results.CoefficientOfCurvature`]: 'Coefficient of Curvature (Cc)',
      [`${prefix}.Results.FinenessModulus`]: 'Fineness Modulus (Fm)',
      [`${prefix}.Results.ReportCoefficientOfUniformity`]: 'Coefficient of Uniformity',
      [`${prefix}.Results.ReportCoefficientOfCurvature`]: 'Coefficient of Curvature',
      [`${prefix}.Results.ReportFinenessModulus`]: 'Fineness Modulus',
    }),
    getSeparationLabelConfig(`${prefix}.WholePortion.Separation`),
    getSeparationLabelConfig(`${prefix}.WholePortion.Separation.FinePortion.Subspecimen.Separation`),
    getSeparationLabelConfig(
      `${prefix}.WholePortion.Separation.FinePortion.Subspecimen.Separation.FinePortion.Subspecimen.Separation`
    )
  );

/**
 * @param prefix prefix for the Separation (e.g. ...WholePortion.Separation)
 */

const getSeparationLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.SeparatingSieveSizeId`]: 'Separating Sieve Size',
    }),
    getPortionLabelConfig(`${prefix}.CoarsePortion`, 'Coarse Portion'),
    getPortionLabelConfig(`${prefix}.FinePortion`, 'Fine Portion'),
    getPortionLabelConfig(`${prefix}.FinePortion.Subspecimen`, 'Subspecimen')
  );

/**
 * @param prefix prefix for the Separation (e.g. ...WholePortion.Separation.CoarsePortion)
 * @param captionPrefix prefix for mass captions (e.g. 'Coarse Portion')
 */
const getPortionLabelConfig = (prefix: string, captionPrefix: string) =>
  convertLabelMapToConfig({
    [`${prefix}.Separation.SeparatingSieveSizeId`]: 'Separating Sieve Size',
    [`${prefix}.Masses.MassMeasurement.Equipment.Balance`]: 'Balance',
    [`${prefix}.Masses.MassMeasurement.TareAndDryMass`]: `Tare and ${captionPrefix} Dry Mass`,
    [`${prefix}.Masses.MassMeasurement.TareMass`]: `Tare Mass`,
    [`${prefix}.Masses.DryMass`]: `${captionPrefix} Dry Mass`,
    [`${prefix}.Masses.MassUpscaleFactor`]: 'Mass Upscale Factor',
    [`${prefix}.Sieving.Equipment.Balance`]: 'Balance',
    [`${prefix}.Sieving.Equipment.SieveSet`]: 'Sieve Set',
    [`${prefix}.Sieving.ExpectedIndividualPanMassRetained`]: 'Expected Mass Passing',
  });
export default getLabelConfig;
